import { Canvas } from "@react-three/fiber";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import {
  OrbitControls,
  Stage,
  Bounds,
  Center,
  Environment,
} from "@react-three/drei";
import { Suspense } from "react";

const Model = () => {
  let params = new URLSearchParams(document.location.search);
  let modelURL = params.get("modelURL");

  const gltf = useLoader(GLTFLoader, modelURL, (loader) => {
    const dracoLoader = new DRACOLoader();
    dracoLoader.setDecoderPath("https://www.gstatic.com/draco/v1/decoders/");
    loader.setDRACOLoader(dracoLoader);
  });

  return (
    <>
      <primitive object={gltf.scene} scale={10} />
    </>
  );
};

export default function App() {
  return (
    <>
      <Canvas camera={{ fov: 1, position: [10, 15, 20] }}>
        <Suspense fallback={null}>
          <Stage
            adjustCamera
            intensity={0.1}
            shadows="contact"
            preset="portrait"
          ></Stage>
          <Model />
          <Stage />
        </Suspense>

        <OrbitControls />
      </Canvas>
    </>
  );
}
